<template>
  <div class="sharing-options" :style="style">
    <sharing-options-link network="facebook" class="sharing-options__link" v-bind="valuesFor('facebook')" />
    <sharing-options-link network="twitter" class="sharing-options__link" v-bind="valuesFor('twitter')" />
    <sharing-options-link network="linkedin" class="sharing-options__link" v-bind="valuesFor('linkedin')" />
    <sharing-options-link network="email" class="sharing-options__link" v-bind="valuesFor('email')" />
    <div class="sharing-options__link sharing-options__link--embed">
      <a @click="showEmbedForm">
        <IconEmbed />
      </a>
    </div>
    <b-modal hide-footer ref="embedForm" title="Embed on your website" class="text-dark">
      <embed-form no-title no-preview ></embed-form>
    </b-modal>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import reduce from 'lodash/reduce'
  import IconEmbed from '@/components/IconEmbed'
  import utilMixins from '@/mixins/utils'
  /**
   * SharingOptions
   */
  export default {
    name: 'CustomSharingOptions',
    mixins: [utilMixins],
    components: {
      IconEmbed
    },
    props: {
      /**
       * URL to be shared.
       */
      url: {
        type: String,
        default: ``
      },
      title: {
        type: String,
        default: ``
      },
      /**
       * Direction of the sharing options. Can be: <em>row</em>, <em>row-reverse</em>,
       * <em>column</em> or <em>column-reverse</em>.
       */
      direction: {
        default: 'row',
        validator (value) {
          return ['row', 'row-reverse', 'column', 'column-reverse'].indexOf(value) !== -1
        }
      },
      /**
       * Sharing contents which can be generic (<em>title</em>, <em>description</em>, etc)
       * or specific to a network (<em>twitter_title</em>, <em>facebook_description</em>, etc).
       */
      values: {
        type: Object,
        default: () => ({})
      },
      /**
       * The list of all the keys to automatically inject in each social button.
       */
      valuesKeys: {
        default: () => ['url', 'title', 'description', 'media', 'user'],
        type: Array
      }
    },
    methods: {
      showEmbedForm () {
        return this.$refs.embedForm.show()
      },
      valuesFor (network) {
        const values = Object.assign(this.metaValues, this.values)
        return reduce(this.valuesKeys, (res, key) => {
          res[key] = get(values, `${network}_${key}`, values[key])
          return res
        }, {})
      },
      defaultValueFor(value) {
        return value
      },
      parseUrl(url) {

        const main_domain = `https://www.icij.org/investigations/pandora-papers/power-players/`

        if(url == ``) {
          if(this.$route.name == 'list')
            return main_domain
          if(this.$route.name == 'player.profile')
            return `${main_domain}?player=${this.$route.params.id}`
          if(this.$route.name == 'region.page')
            return `${main_domain}?region=${this.$route.params.region_id}`
          if(this.$route.name == 'provider.page')
            return `${main_domain}?provider=${this.$route.params.provider_id}`
        }

        return url
      },
      parseDesc(title) {
        if(this.$route.name == 'list')
          return this.$t('social.all')
        if(this.$route.name == 'player.profile')
          return `${this.$t('social.player')} ${title}`
        if(this.$route.name == 'region.page')
          return `${this.$t('social.region')} ${title}`
      },
      parseTitle(title) {
        if(title == '')
          return this.$t('social.titleall')
        return title + this.$t('social.title_append')
      },
      parseMedia() {
        return 'https://projects.icij.org/investigations/pandora-papers/power-players/power_players_social.png'
      }
    },
    computed: {
      style () {
        return {
          'flex-direction': this.direction
        }
      },
      metaValues () {
        return {
          'url': this.parseUrl(this.url),
          'title': this.parseTitle(this.title),
          'description': this.parseDesc(this.title),
          'facebook_title': "Pandora Papers - Power Players",
          'facebook_description': this.parseDesc(this.title),
          'facebook_media': this.parseMedia(this.title),
          'twitter_media': this.parseMedia(this.title),
          'twitter_user': 'icijorg'
        }
      }
    }
  }
</script>